/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FilledInput from '@mui/material/FilledInput';
import FormHelperText from '@mui/material/FormHelperText';
import useStyles from './useStyles';

const ReadonlyField = ({ label, value, name, helperText, className = {} }) => {
  const [inputValue, setInputValue] = useState('');
  const { classes } = useStyles();
  useEffect(() => {
    setInputValue(value);
  }, [value]);
  const onChange = (e) => {
    setInputValue(e.target.value);
  };
  return (
    <FormControl fullWidth variant="filled" className={className}>
      <InputLabel htmlFor={name} className={classes.label} shrink={false}>
        {label}
      </InputLabel>
      <FilledInput
        id={name}
        name={name}
        value={inputValue}
        type="text"
        disabled
        disableUnderline
        classes={{ root: classes.root, disabled: classes.disabled, input: classes.input }}
        onChange={onChange}
      />
      {helperText && helperText.length > 0 && (
        <FormHelperText sx={{ ml: 0.5 }}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

ReadonlyField.defaultProps = {
  helperText: '',
};

ReadonlyField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  className: PropTypes.string,
};

export default ReadonlyField;
